export default __webpack_public_path__ + "static/dont-icon-color-4ea4d5aa766c94a43e019cf84ee77c91.png";